import React, { useContext } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Button, Form, TextArea } from "carbon-components-react";
import { Redo32 } from "@carbon/icons-react";

import { DecisionCriteriaMismatch } from "@eave/shared/types/api";

import { SandboxScenarioContext } from "../../SandboxScenarioProvider";

const styles = require("./styles.module.scss");

const ReworkForm = ({ err }: { err: DecisionCriteriaMismatch | null }) => {
  const { submitReworkRequest, submitting, request, results } = useContext(SandboxScenarioContext);

  return (
    <Formik
      validationSchema={Yup.object().shape({
        description: Yup.string().required("required"),
      })}
      initialValues={{ description: "" }}
      onSubmit={async (values, { resetForm }) => {
        const { description } = values;

        await submitReworkRequest({
          description,
          sandbox_request: request,
          sandbox_response: results,
        });

        resetForm();
      }}
    >
      {({ values, errors, handleSubmit, handleBlur, handleChange, touched }) => {
        const { description } = values;
        return (
          <>
            <h2>Rework request</h2>
            <Form
              onSubmit={e => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <div className={styles.description}>
                <TextArea
                  disabled={submitting || Boolean(err)}
                  id="description"
                  name="description"
                  labelText=""
                  rows={10}
                  value={description}
                  invalid={!!errors.description && touched.description}
                  invalidText={errors.description}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </div>
              <div className={styles.submit}>
                <Button
                  kind="primary"
                  type="submit"
                  renderIcon={Redo32}
                  disabled={submitting || Boolean(err)}
                >
                  Submit rework request
                </Button>
              </div>
            </Form>
          </>
        );
      }}
    </Formik>
  );
};

export default ReworkForm;
